import { useUserSession } from '@solinkcorp/authentication';
import { CallhomeApi } from 'clients';

/** simple wrapper that instantiates CallhomeApi with acces token from useUserSession instead of
 * deprecated AuthService.authToken
 */
function useCallhomeClient() {
  const user = useUserSession();

  return CallhomeApi(user.accessToken);
}

export default useCallhomeClient;
